module.exports = __webpack_public_path__ + "public/img/yuangongguanli.414d5bb8.png";